import avatar from "../../../img/avatar.jpg";
import React from "react";
import SingleClientReport from "../SingleClientReport";

const ClientAbout = ({client}) => {
    const {id} = client;

    return (
        <>
            <div className="card mb-3">
                <div className="card-header">
                    <h5 className="card-title mb-0">Mijoz
                        ma'umotlari</h5>
                </div>
                <div className="card-body text-center">
                    <div className="row">
                        <div className="col-md-3">
                            <img src={avatar} alt="Christina Mason"
                                 className="img-fluid rounded-circle m-2 mb-2"
                                 width="128" height="128"/>
                            <h5 className="card-title mb-0">{client?.name} </h5>
                            <div
                                className="text-muted mb-2">{client?.email}</div>
                        </div>
                        <div className="col-md-9">

                            <div className="d-flex align-items-center">
                                <div className="card-title m-2">INN:</div>
                                <div
                                    className="text-muted m-0">{client?.inn}</div>
                            </div>

                            <div className="d-flex align-items-center">
                                <div className="card-title m-2">Telefon:</div>
                                <div
                                    className="text-muted m-0">{client?.phone}</div>
                            </div>


                            <div className="d-flex align-items-center">
                                <div className="card-title m-2">Bank
                                    akkount:
                                </div>
                                <div
                                    className="text-muted m-0">{client?.bank_account}</div>
                            </div>

                            <div className="d-flex align-items-center">
                                <div className="card-title m-2">Turi:
                                </div>
                                <div
                                    className="text-muted m-0">{client?.type}</div>
                            </div>

                            <div className="d-flex align-items-center">
                                <div className="card-title m-2">Bog'langan
                                    yetkazuvchi:
                                </div>
                                <div
                                    className="text-muted m-0">{client?.supplier?.name}</div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div className="card-title m-2">Tashkilot
                                    xodimi:
                                </div>
                                <div
                                    className="text-muted m-0">{client?.contractor}</div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header">Hisobot chiqarish(<b>Qabul qilingan va Sotuv qiymati</b>)</div>
                <div className="card-body">
                    <SingleClientReport id={id}/>
                </div>
            </div>
        </>
    )
}

export default ClientAbout;